export const formatToSend = (phone) =>
  phone
    .replace(/\s/g, '')
    .replace(/\+7/g, '')
    .replace(/\D/g, '')



// WEBPACK FOOTER //
// ./src/helpers/index.js